export default {
  icon_text: 'Închis',
  buttons: {
    ok: 'Ok',
  },
};
